( function ( $ ) {
	'use strict';

	$( window ).on( 'load', function () {

		var moveMenu = function () {
			var menuContainer = $( '.header-widget-area' );
			var open = $( '.menu-open' );
			if ( window.innerWidth > 1023 ) {
				menuContainer = menuContainer.detach();
				menuContainer.appendTo( '.site-nav-menus' );
				menuContainer.show();
				var parentwidth = $( '.menu-item-has-children' ).width();
				$( '.sub-menu' ).width( parentwidth );
			} else {
				menuContainer = menuContainer.detach();
				menuContainer.appendTo( '.site-header' );
				if ( open.is( ':visible' ) && $( 'body' ).hasClass( 'show-responsive-menu' ) ) {
					menuContainer.hide();
				}
				$( '.sub-menu' ).width( 'inherit' );
			}
		};
		$( 'body' ).bind( 'updateMenu', moveMenu );

		var toggleClickSubMenu = function ( e ) {
			var subMenuSiblings =
				$( this )
				.parent()
				.siblings( '.menu-item-has-children' )
				.children( '.sub-menu:visible' );

			subMenuSiblings.siblings( 'a' ).removeClass( 'active-sub-menu-parent' );
			subMenuSiblings.slideToggle( 'fast' );

			$( this ).siblings( '.sub-menu' ).slideToggle( 'fast' );
			$( this ).toggleClass( 'active-sub-menu-parent' );

			// Cancel the default action to avoid jumping to the top of the page.
			e.preventDefault();
		};

		var toggleHoverSubMenu = function ( e ) {
			var subMenuSiblings =
				$( this )
				.siblings( '.menu-item-has-children' )
				.children( '.sub-menu:visible' );

			subMenuSiblings.siblings( 'a' ).removeClass( 'active-sub-menu-parent' );

			$( this ).children( '.sub-menu' ).stop();
			$( this ).children( '.sub-menu' ).slideToggle( 'fast' );
			$( this ).children( 'a' ).toggleClass( 'active-sub-menu-parent' );

			// Cancel the default action to avoid jumping to the top of the page.
			e.preventDefault();
		};

		var updateResponsiveMenu = function () {
			var body = $( 'body' );
			var subMenuParent = $( '.menu-item-has-children' );
			subMenuParent.off();
			subMenuParent.children( 'a' ).off();
			if ( window.innerWidth > 1023 ) {
				body.removeClass( 'show-responsive-menu' );
				subMenuParent.hover( toggleHoverSubMenu );
			} else {
				$('.site-nav-menus').css('display', 'flex');
				body.addClass( 'show-responsive-menu' );
				subMenuParent.children( 'a' ).click( toggleClickSubMenu );
			}
			body.trigger( 'updateMenu' );
		};
		updateResponsiveMenu();
		$( window ).resize( updateResponsiveMenu );

		/**
		 * Show/hide responsive menu
		 */
		$( '#responsive-menu-icon' ).find( 'span' ).click( function () {
			//show/hide the primary & secondary menus
			var subMenus = $( '.sub-menu' );
			subMenus.hide();
			subMenus.siblings( 'a' ).removeClass( 'active-sub-menu-parent' );
			$( '.header-widget-area' ).slideToggle();
			$( '.nav-secondary' ).slideToggle();
		} );
	} );
}( jQuery ) );